module.exports = __webpack_public_path__ + "static/img/3.935a073.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fan/3.png
// module id = 8ovE
// module chunks = 1